import { DAYS_PROJECT_RETAINED, DAYS_UNTIL_PROJECT_STALE } from '../constants';

export const getDaysLeft = (dateCreated: Date) => {
  const daysSinceCreation = Math.floor(
    (Date.now() - dateCreated.getTime()) / (24 * 60 * 60 * 1000),
  );
  // Don't show alert if project is less than a day old
  if (daysSinceCreation < DAYS_UNTIL_PROJECT_STALE) {
    return null;
  }
  return daysSinceCreation < DAYS_PROJECT_RETAINED
    ? Math.max(0, DAYS_PROJECT_RETAINED - daysSinceCreation)
    : null;
};
